<div class="container">

  <app-header-dialog [iconName]="'post_add'">
    Documentos
  </app-header-dialog>

  <div class='tab-content'>

    <form name="entityForm" [formGroup]='entityForm' autocomplete="off">

      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Usuário</mat-label>
        <input readonly matInput type="text" [errorStateMatcher]="matcher"
          [formControl]="entityForm.controls.member_name" autocomplete="off">
      </mat-form-field>

      <!--
      <textarea class='text-area' matInput [errorStateMatcher]="matcher" placeholder="Observações"
        [formControl]="entityForm.controls.obs" autocomplete="off">
      </textarea>
      -->

    </form>


    <mat-table [dataSource]="_documentService.documentDataSource" style='height:460px; border-bottom: 1px solid black;'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>post_add</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.date | date:'dd/MM/yyyy' }} </mat-cell>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="filename">
        <mat-header-cell *matHeaderCellDef> Documento </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div style="display: flex; flex-direction: column; ">
            <div>
              <a mat-button (click)='goToLink(element.url)'>
                {{element.filename}}
              </a>
            </div>
            <div *ngIf="element.folder_name" style="padding: 0px 5px 5px 15px;">
              {{element.folder_name}}
            </div>
            <div *ngIf="!element.folder_name" style="padding: 0px 5px 5px 15px;">
              <i>Sem pasta</i>
            </div>
          </div>

        </mat-cell>
      </ng-container>

      <!--approved Column -->
      <ng-container matColumnDef="approved">
        <mat-header-cell *matHeaderCellDef> Aprovado </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.approved'>
            <img src='/assets/images/status/img_green.png'>
          </span>
          <span *ngIf='!element.approved'>
            <img src='/assets/images/status/img_silver.png'>
          </span>
        </mat-cell>
      </ng-container>


      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openApproveDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='deleteDocument(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

  </div>


  <!--
  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <div [ngClass]="{hidden: !spinner}">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>


  </div>
  -->

</div>